/**
 * Select.
 *
 * Native <select> with our input styling. Disabled gets the same muted look
 * as Input. For very large option lists (>50) we'd swap in a combobox; not
 * needed in v1.
 */
import type { SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export function Select({ invalid = false, className, children, ...rest }: SelectProps) {
  return (
    <div className="relative">
      <select
        className={cn(
          'block h-9 w-full appearance-none rounded-md border bg-surface px-3 pr-8 text-sm text-primary disabled:bg-subtle disabled:text-tertiary disabled:cursor-not-allowed',
          invalid ? 'border-status-danger' : 'border-border-default',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-tertiary"
        strokeWidth={1.5}
      />
    </div>
  );
}
